export const DETAIL_VIEW_TEST_ID = 'detail-view-test-id';
export const MASTER_VIEW_TEST_ID = 'master-view-test-id';
export const ANIMATION_DURATION = 200;
